import { GetUser } from '../../../apps/checkout/src/client/graphql/queries'
import { User } from '../../types/user'
import useIdToken from './use-id-token'

const useQueryFallback = (): any => undefined

export function useUser(useQuery = useQueryFallback as any): { user: User } {
  const { idToken } = useIdToken()

  const result = useQuery(GetUser, {
    // ssr: false,
    context: { version: 2, headers: { Authorization: `Bearer ${idToken}` } },
    skip: !idToken,
  })

  return {
    user: result?.data?.currentUser,
  }
}
